import { MaintenanceFormData } from '@hkm/components/shared/Templates/Maintenance/MaintenanceCreateForm/model/maintenanceFormData';

export function getMaintenanceFormValidationRelevantData(data: MaintenanceFormData): any {
  return {
    roomNumbers: data.roomNumbers,
    fromTime: data.fromTime,
    toTime: data.toTime
  };
}



// WEBPACK FOOTER //
// ./src/components/shared/Templates/Maintenance/MaintenanceCreateForm/Validation/getMaintenanceFormValidationRelevantData.ts